import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import BlogSingle from '../../components/BlogDetails/BlogSingle'
import { useParams } from 'react-router-dom'
import blogs from '../../api/blogs'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

const BlogDetailsFull: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();

    // ✅ Get current blog safely
    const currentBlog = blogs.find((item) => item.slug === slug);
    
    return(
        <Fragment>
            <Navbar hclass={'wpo-header-style-1'}/>
            <PageTitle pageTitle={'Latest News'} pagesub={'Blog'}/> 
            <BlogSingle pageStyle={'blog-single-fullwidth'} blog={currentBlog}/>
            <Footer footerClass={'wpo-site-footer-s1'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default BlogDetailsFull;